import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const STORAGE_KEY = 'daily_banner_shown'; // object: { vi: "YYYY-MM-DD", en: "YYYY-MM-DD" }

const DailyBannerModal = ({ onClickBanner }) => {
  // TẠM ẨN BANNER – Xóa dòng return null bên dưới để bật lại
  return null;
  const { i18n } = useTranslation();
  const [visible, setVisible] = useState(false);

  const lang = (i18n.language || 'vi').startsWith('en') ? 'en' : 'vi';
  const bannerSrc = lang === 'en' ? '/banner_en.png' : '/banner_vi.png';

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0]; // "YYYY-MM-DD"

    // Đọc object đã lưu { vi: "...", en: "..." }
    let shown = {};
    try {
      shown = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch {}

    // Chỉ hiện nếu ngôn ngữ này chưa được show hôm nay
    if (shown[lang] !== today) {
      setVisible(true);
      shown[lang] = today;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(shown));
    }
  }, [lang]); // re-check khi ngôn ngữ thay đổi

  const handleClose = () => setVisible(false);

  if (!visible) return null;

  return (
    <div
      onClick={handleClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(17,24,39,0.55)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: 'relative',
          maxWidth: '640px',
          width: '90vw',
          borderRadius: '16px',
          overflow: 'hidden',
          boxShadow: '0 24px 64px rgba(0,0,0,0.3)',
        }}
      >
        <img
          src={bannerSrc}
          alt="banner"
          style={{
            display: 'block', width: '100%', height: 'auto',
            cursor: onClickBanner ? 'pointer' : 'default',
          }}
          onClick={() => {
            if (onClickBanner) {
              handleClose();
              onClickBanner();
            }
          }}
        />
        <button
          onClick={handleClose}
          style={{
            position: 'absolute',
            top: 10,
            right: 10,
            width: 32,
            height: 32,
            borderRadius: '50%',
            border: 'none',
            background: 'rgba(0,0,0,0.45)',
            color: '#fff',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 18,
            lineHeight: 1,
          }}
          aria-label="Đóng"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default DailyBannerModal;
